import { getRepaymentInfo, cmbcWithdraw, cmbcRechargeRepay, getRepaymentInfoByApplyId, calc, getCurrList, getVendorCardList, setDefaultCard, redirectRepayV6 } from '@/api/repay'
import { each as _each, find as _find, filter as _filter, some as _some, map as _map, max as _max } from 'lodash'
import Vue from 'vue';
import Store from 'store'
const getDomain = () => {
  let protocol = window.location.protocol
  let host = window.location.host
  return [protocol, host].join('//')
}
const state = {
  repayInfo: {},
  repayLoaded: false,
  currentRepay: {},
  calcInfo: {},
  checkedAll: true,
  overdue: false,
  applyCount: 0, // 在贷笔数
  curTotalAmt: 0, // 30天应还金额
  repaymentNote: '', // 还款提示
  applyList: [], // 项目列表
  boundCards: [], // 已绑定的资方还款卡列表
  repayProductIds: [], // 还款计划存在的产品
}
const mutations = {
  'SET_REPAY_INFO' (state, payload) {
    state.repayInfo = payload
    state.repayProductIds = _filter(state.repayInfo.repayPlanList, (plan) => {
      return !plan.productId
    })
    if (_some(state.repayInfo.repayPlanList, (plan) => {
      return plan.overdue
    })) {
      state.overdue = true
    } else {
      state.overdue = false
    }
    state.repayLoaded = true
  },
  'SET_REPAY_PLAN_CHECKED' (state, payload) {
    if (payload) {
      let repay = _find(state.currentRepay.curRepayPlanList, (item) =>{
        return item.terms === payload.terms
      })
      if (repay) {
        repay.checked = !repay.checked
      }
      if (_some(state.currentRepay.curRepayPlanList, (item) => {
        return item.checked === false
      })) {
        state.checkedAll = false
      } else {
        state.checkedAll = true
      }
    } else {
      state.checkedAll = !state.checkedAll
      if (state.checkedAll) {
        _each(state.currentRepay.curRepayPlanList, (item) => {
          item.checked = true
        })
      } else {
        _each(state.currentRepay.curRepayPlanList, (item) => {
          item.checked = false
        })
      }
    }
  },
  'SET_CURRENT_REPAY' (state, payload) {
    state.currentRepay = payload
    if (_some(state.currentRepay.curRepayPlanList, (item) => {
      return item.overdue
    })) {
      state.overdue = true
    } else {
      state.overdue = false
    }
  },
  'SET_CALC_INFO' (state, payload) {
    state.calcInfo = payload
  },
  'RESET_REPAY' (state) {
    state.repayInfo = {}
    state.repayLoaded = false
    state.currentRepay = {}
    state.calcInfo = {}
    state.checkedAll = true
    state.overdue = false
  },
  'SET_CURRLIST_INFO' (state, payload) {
    state.applyCount = payload.applyCount;
    state.curTotalAmt = payload.curTotalAmt;
    state.repaymentNote = payload.repaymentNote;
    state.applyList = payload.applyList;
  },
  'SET_BOUND_CARDS' (state, payload) {
    state.boundCards = payload;
  }
}
const actions = {
  getRepaymentInfo ({ state, commit }) {
    if (!state.repayLoaded) {
      state.repayLoaded = true
      return getRepaymentInfo().then((data) => {
        commit('SET_REPAY_INFO', data)
      })
    }
  },
  getRepaymentInfoByApplyId ({ commit }, payload) {
    return getRepaymentInfoByApplyId(payload).then((data) => {
      commit('SET_CURRENT_REPAY', data)
    })
  },
  gotoWithdraw () {
    return cmbcWithdraw()
  },
  calcPrepayment ({ commit }, payload) {
    return calc(payload).then((data) => {
      commit('SET_CALC_INFO', data.calcResult)
      return Promise.resolve()
    })
  },
  repay ({ state, rootState }, payload) {
    let terms = _map(_filter(state.currentRepay.curRepayPlanList, (item) => {
      return item.checked
    }), (plan) => {
      return plan.terms
    })
    if (terms.length > 0) {
      let maxTerms = _max(terms)
      if (_some(state.currentRepay.curRepayPlanList, (plan) => {
        return plan.checked === false && maxTerms > plan.terms
      })) {
        return Promise.reject({
          status: 400,
          message: '您选择的还款期前有未还清欠款，请按近期待还款时间顺序操作还款'
        })
      } else {
        // let plan = _find(state.currentRepay.curRepayPlanList, (plan) => {
        //   return plan.terms === maxTerms
        // })
        let plan = payload.plan;
        let baseUrl = Store.get('vue-router-base') || '/'
        baseUrl = baseUrl == '/' ? '' : baseUrl
        return cmbcRechargeRepay({
          balance: rootState.user.userInfo.cmbcFundAvailableBalance || 0,
          callback: payload.callback || encodeURIComponent(getDomain() + baseUrl + '/index'),
          projectId: plan.projectId,
          repayType: 2,
          source: 'dumiao',
          dueDate: plan.planPayAt,
          skin: payload.skin,
          app: payload.app,
          productId: plan.productId || "DM-QBXJ",
          callbackString: plan.applyId,
          deviceInfo: decodeURIComponent(Vue.cookie('deviceInfo') || "")
        })
      }
    } else {
      return Promise.reject({
        status: 400,
        message: '请选择还款期数'
      })
    }
  },
  repayV6 ({ state, rootState }, payload) {
    return redirectRepayV6({
      applyId: payload.applyId,
      redirectUrl: payload.redirectUrl,
    })
  },
  prepayment ({ state, rootState }, payload) {
    let plan = _find(state.repayInfo.prepaymentList, (plan) => {
      return plan.applyId == payload.applyId
    })
    if (plan) {
      let now = new Date()
      let year = now.getFullYear()
      let month = now.getMonth() + 1
      let day = now.getDate()
      let baseUrl = Store.get('vue-router-base') || '/'
        baseUrl = baseUrl == '/' ? '' : baseUrl
      return cmbcRechargeRepay({
        balance: rootState.user.userInfo.cmbcFundAvailableBalance || 0,
        callback: payload.callback || encodeURIComponent(getDomain() + baseUrl + '/index'),
        projectId: plan.projectId,
        repayType: 1,
        source: 'dumiao',
        dueDate: [year, month, day].join('-'),
        skin: payload.skin,
        app: payload.app,
        productId: plan.productId || "DM-QBXJ",
        deviceInfo: decodeURIComponent(Vue.cookie('deviceInfo') || "")
      })
    } else {
      return Promise.reject({
        status: 400,
        message: '还款信息错误：' + payload.applyId
      })
    }
  },
  getCurrList ({ commit }, payload) {
    return getCurrList(payload).then((data) => {
      commit('SET_CURRLIST_INFO', data);
      return Promise.resolve()
    })
  },
  getVendorCardList ({ commit }, payload) {
    return getVendorCardList(payload).then((data) => {
      commit('SET_BOUND_CARDS', data.boundCards);
      return Promise.resolve()
    })
  },
  setDefaultCard ({ commit }, payload) {
    return setDefaultCard(payload).then(() => {
      return Promise.resolve()
    })
  }
}
const getters = {
  overdueAmt: state => {
    if (state.overdue) {
      let amt = 0
      if (state.currentRepay.curRepayPlanList) {
        _each((state.currentRepay.curRepayPlanList || []), (item) => {
          if (item.overdue) {
            amt += item.resAmt
          }
        })
      } else if (state.repayInfo.repayPlanList) {
        _each((state.repayInfo.repayPlanList), item => {
          if (item.overdue) {
            amt += item.resAmt
          }
        })
      }
      return amt
    } else {
      return 0
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}